import React from 'react';

export default function SvgVimeo(props) {
	return (
		<svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" width="18" height="15.75" viewBox="0 0 18 15.75" {...props}>
			<path fill="#19b2e5" d="M15.372,1.5c-2.5-.091-4.182,1.34-5.071,4.27a3.234,3.234,0,0,1,1.333-.3c3.164,0-.728,6.116-1.7,6.116-1.141,0-1.828-5.463-2.06-6.955Q7.391,1.529,5.291,1.732A5.944,5.944,0,0,0,2.626,3.367Q1.332,4.554,0,5.737l.847,1.1a5.546,5.546,0,0,1,1.411-.858c2.319,0,2.166,11.266,5.837,11.266,3.526,0,9.733-8.641,9.888-12.1l.01-.008c.1-2.374-.766-3.589-2.62-3.634Z" transform="translate(0 -1.5)" />
		</svg>
	)
}